export default "__VITE_PUBLIC_ASSET__eb28b3be__"